import { isKibouBiTypeFastest } from '@/constants/yusouKibouBiType'
import { isKibouJikanReason } from '@/constants/yusouKibouJikanType'

/**
 * 輸送希望日・時間の表示制御Mixin
 */
export default {
  computed: {
    /** 引取希望日時が表示されるか */
    isHikitoriKibouDateTimeVisible() {
      return !isKibouBiTypeFastest(this.form.HIKITORI_KIBOU_BI_TYPE)
    },

    /** 引取希望時間の理由が表示されるか */
    isHikitoriKibouJikanReasonVisible() {
      return isKibouJikanReason(this.form.HIKITORI_KIBOU_JIKAN_TYPE)
    },

    /** 納車希望日時が表示されるか */
    isNosyaKibouDateTimeVisible() {
      return !isKibouBiTypeFastest(this.form.NOSYA_KIBOU_BI_TYPE)
    },

    /** 納車希望時間の理由が表示されるか */
    isNosyaKibouJikanReasonVisible() {
      return isKibouJikanReason(this.form.NOSYA_KIBOU_JIKAN_TYPE)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/mixin/YusouKibouMixin.js